export function transformAreaCoverage(project) {

    if (!project) {
        return
    }

    let areaOfInterest = []
    if (project.areaOfInterest && project.areaOfInterest.coordinates) {

        let areaOfInterestExteriorRing = project.areaOfInterest.coordinates[0]
        areaOfInterestExteriorRing.pop()
        areaOfInterest = areaOfInterestExteriorRing.map(point => {
            return {lat: point[1], lng: point[0]}
        })
    }

    let noFlyZones = []
    if (project.noFlyZones && project.noFlyZones.coordinates) {

        noFlyZones =
            project.noFlyZones.coordinates.map(polygon => {
                let polygonExteriorRing = polygon[0]
                polygonExteriorRing.pop()
                return polygonExteriorRing.map(point => {
                    return {lat: point[1], lng: point[0]}
                })
            })
    }

    let areaCoveragePaths = []
    let portions = []
    if (project.areaCoveragePaths) {

        [portions, areaCoveragePaths] = transformAreaCoveragePathsFromGeoJSON(project.areaCoveragePaths,
            project.numberOfDrones)
    }

    let initialPositions = []
    if(project.initialPositions && project.initialPositions.coordinates) {
        initialPositions = project.initialPositions.coordinates.map(point => {
            return {lat: point[1], lng: point[0]}
        })
    }

    return [areaOfInterest, noFlyZones, areaCoveragePaths, portions, initialPositions];
}

export function transformAreaCoveragePathsFromGeoJSON(areaCoveragePaths, numberOfDrones) {

    let portions = []

    if(areaCoveragePaths.length === 0) {
        for(let i = 0; i < numberOfDrones; i++) {
            portions.push(100/numberOfDrones)
        }
    } else {
        for(let i = 0; i < areaCoveragePaths.length; i++) {

            portions.push(areaCoveragePaths[i].portion * 100)
            areaCoveragePaths[i] = areaCoveragePaths[i].waypoints.map(waypoint => {
                return {lat: waypoint.point.coordinates[1], lng: waypoint.point.coordinates[0]}})
        }
    }
    return [portions, areaCoveragePaths]
}

export function transformScatteredRegionsVisitationPathsFromGeoJSON(scatteredRegionsVisitationPaths) {


        // for(let i = 0; i < scatteredRegionsVisitationPaths.length; i++) {
        //
        //     scatteredRegionsVisitationPaths[i] = scatteredRegionsVisitationPaths[i].waypoints.map(waypoint => {
        //         return {lat: waypoint.point.coordinates[1], lng: waypoint.point.coordinates[0]}})
        // }

    return scatteredRegionsVisitationPaths
}



export function convertAreaCoveragePathsPortionsGeo(areaCoveragePaths, portions) {

    if(!areaCoveragePaths || areaCoveragePaths.length === 0) {
        return
    }
    let areaCoveragePathsPortionsGeo = []
    for(let i = 0; i < areaCoveragePaths.length; i++) {
        areaCoveragePathsPortionsGeo.push({"portion": portions[i] / 100, "waypoints": areaCoveragePaths[i].map(waypoint => {
            return {"point": {"type": "Point", "coordinates": [waypoint.lng, waypoint.lat]}}
            })})
    }
    return areaCoveragePathsPortionsGeo
}

export function convertScatteredRegionsVisitationPathsGeo(scatteredRegionsVisitationPaths) {

    if(!scatteredRegionsVisitationPaths || scatteredRegionsVisitationPaths.length === 0) {
        return
    }
    let scatteredRegionsVisitationPathsGeo = []
    for(let i = 0; i < scatteredRegionsVisitationPaths.length; i++) {
        scatteredRegionsVisitationPathsGeo.push({"waypoints": scatteredRegionsVisitationPaths[i].map(waypoint => {
                return {"point": {"type": "Point", "coordinates": [waypoint.lng, waypoint.lat]}}
            })})
    }
    return scatteredRegionsVisitationPathsGeo
}

export function convertWaypointsWithAltitude(areaCoveragePaths, altitude) {

    if(!areaCoveragePaths || areaCoveragePaths.length === 0) {
        return
    }

    let waypoints = []

    for(let i = 0; i < areaCoveragePaths.length; i++) {
        waypoints.push(areaCoveragePaths[i].map(waypoint => {
            return {"altitude": altitude, "point": {"type": "Point", "coordinates": [waypoint.lng, waypoint.lat]}}
        }))
    }
    return waypoints
}



export function transformScatteredRegionsVisitation(project) {

    if (!project) {
        return
    }

    let scatteredRegionsOfInterest = []

    if(project.scatteredRegionsOfInterest && project.scatteredRegionsOfInterest.coordinates) {
        project.scatteredRegionsOfInterest.coordinates.forEach(region =>
        {
            let regionExteriorRing = region[0]
            regionExteriorRing.pop()
            scatteredRegionsOfInterest.push(
                regionExteriorRing.map(point => {
                return {lat: point[1], lng: point[0]}
            }))
        })
    }

    let scatteredRegionsVisitationPaths = []
    if(project.scatteredRegionsVisitationPaths) {
        scatteredRegionsVisitationPaths = transformScatteredRegionsVisitationPathsFromGeoJSON(
            project.scatteredRegionsVisitationPaths)
    }


    let initialPositions = []
    if(project.initialPositions && project.initialPositions.coordinates) {
        initialPositions = project.initialPositions.coordinates.map(point => {
            return {lat: point[1], lng: point[0]}
        })
    }

    return [scatteredRegionsOfInterest, scatteredRegionsVisitationPaths, initialPositions]
}

export function convertRefToPolygonGeo(polygonRef)  {


    if(!polygonRef) {
        return null
    }
    let polygonExteriorRing = []

    const polyArray = polygonRef.getPath().getArray();
    polyArray.forEach(function (path) {
        polygonExteriorRing.push([path.lng(), path.lat()]);
    });

    let polyLength =  polygonExteriorRing.length

    if(polygonExteriorRing[0][0] != polygonExteriorRing[polyLength - 1][0] ||
        polygonExteriorRing[0][1] != polygonExteriorRing[polyLength - 1][0]) {
        polygonExteriorRing.push(polygonExteriorRing[0])
    }

    return {type: "Polygon", coordinates: [polygonExteriorRing]}
}

export function convertRefsToMultiPolygonGeo(multiPolygonRefs)  {

    if(!multiPolygonRefs || multiPolygonRefs.length === 0) {
        return null
    }

    let polygons = []

    multiPolygonRefs.forEach(polygonRef => {

        let polygonExteriorRing = []

        const polyArray = polygonRef.getPath().getArray();
        polyArray.forEach(function (path) {
            polygonExteriorRing.push([path.lng(), path.lat()]);
        });

        let polyLength =  polygonExteriorRing.length
        if(polygonExteriorRing[0][0] != polygonExteriorRing[polyLength - 1][0] ||
            polygonExteriorRing[0][1] != polygonExteriorRing[polyLength - 1][0]) {
            polygonExteriorRing.push(polygonExteriorRing[0])
        }

        polygons.push([polygonExteriorRing])
    })
    return {type: "MultiPolygon", coordinates: polygons};
}

export function convertRefToMultiPointGeo(multiPointRefs) {

    if(!multiPointRefs) {
        return null
    }

    let points = []
    multiPointRefs.forEach(pointRef => {
        const position = pointRef.getPosition();
        points.push([position.lng(), position.lat()])
    })
    return {type: "MultiPoint", coordinates: points};
}

export function convertCalculatedScatteredWaypoints(waypoints) {}

